import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  fetchNeighbourhoodPerks,
  selectNeighbourhoodPerksById,
} from '../../../reducers/Organisation/neighbourhoodPerksReducer'
import CollectionItem from '../../Collection/CollectionItem'
import CreatePerks from '../../CreatePerks/CreatePerks'
import { selectBuildingById } from '../../../reducers/buildingSelectorReducer'

const OrganisationPerks = ({ params }) => {
  const { t } = useTranslation(['organisation'])
  const dispatch = useDispatch()

  const { buildingId } = params
  const buildingData = useSelector((state) => selectBuildingById(state)(buildingId))

  const [data, setData] = useState({ isVisible: false, perksData: null })

  const neighbourhoodPerksData = useSelector((state) =>
    selectNeighbourhoodPerksById(state, buildingId),
  )

  useEffect(() => {
    if (buildingId) {
      dispatch(fetchNeighbourhoodPerks(buildingId))
    }
  }, [buildingId, dispatch])

  const createNeighbourhoodPerk = () => {
    setData((prev) => ({ ...prev, isVisible: true }))
  }

  const editNeighbourhoodPerk = (perksData) => {
    setData({ perksData, isVisible: true })
  }

  const closeModal = () => {
    setData({ perksData: null, isVisible: false })
  }

  const isNew = typeof buildingData !== 'undefined' && typeof buildingData.id === 'undefined'

  return (
    <div className={`ctp-perks`}>
      <div className="ctp-perks__header">
        <h2>{t('organisation:places.perks.title')}</h2>
        {buildingData && <h3>{buildingData.name}</h3>}
      </div>
      {!isNew ? (
        <div>
          <button className="ctp-sidebar-button" onClick={createNeighbourhoodPerk}>
            {t('organisation:shared.actions.addNew')}
          </button>
          {neighbourhoodPerksData && neighbourhoodPerksData.length > 0 ? (
            <div className="ctp-shop-list">
              {neighbourhoodPerksData.map((perk) => (
                <CollectionItem additionalClass="ctp-shop-item" key={perk.id}>
                  <span>{perk.name}</span>
                  <button
                    className="button button-primary auto-width"
                    onClick={() => editNeighbourhoodPerk(perk)}
                  >
                    {t('organisation:promoCodes.list.show')}
                  </button>
                </CollectionItem>
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        <p>{t('organisation:places.perks.firstAddBuilding')}</p>
      )}
      {data.isVisible && (
        <CreatePerks buildingId={buildingId} close={closeModal} perksData={data.perksData} />
      )}
    </div>
  )
}

OrganisationPerks.propTypes = {
  params: PropTypes.object.isRequired,
}

export default OrganisationPerks
